<!-- 商品组信息 -->
<template>
  <div>
    <div class="container">
      <div class="title">
        <span>商品基本信息</span>
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="商品组:按商品属性自动划分商品组合"
          placement="right"
        >
          <el-button type="text"><i class="el-icon-question"></i></el-button>
        </el-tooltip> -->
      </div>
      <div class="info-content">
        <div class="info-form">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="所属分类:" prop="pass">
                  <!-- <el-input
                    style="width: 300px"
                    v-model="ruleForm.category"
                    autocomplete="off"
                    disabled
                  ></el-input> -->
                  <span class="">{{ ruleForm.category }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="brand-box">
                  <el-form-item label="商品品牌(选填):" prop="brand">
                    <el-select
                      style="width: 190px"
                      v-model="ruleForm.brand"
                      placeholder="商品品牌"
                      @change="selectBrand"
                    >
                      <el-option
                        v-for="bitem in brandList"
                        :key="bitem.brandId"
                        :label="bitem.brandName"
                        :value="bitem.brandId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <span class="tip-wrap" style="min-height: 33px;">若找不到您想选择的品牌请联系<i>010-85539100</i>或发邮件至<i>wzwangyali@sinopec.com</i>进行添加。</span>	 -->
                  <span class="pointer apply-brand" @click="goToApply"
                    >品牌申请</span
                  >
                  <!-- <router-link
                    style="margin-bottom: 18px; margin-left: 10px"
                    to="/rateManage"
                    >申请新品牌</router-link
                  > -->
                </div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="税率:" prop="tax">
                  <el-select
                    style="width: 190px"
                    v-model="ruleForm.showTax"
                    placeholder="税率"
                    @change="selectRate"
                  >
                    <el-option
                      v-for="taxitem in taxList"
                      :key="taxitem.taxRateId"
                      :label="taxitem.taxRate"
                      :value="taxitem.taxRateId"
                    >
                      <span>{{ taxitem.taxRate }}%</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="info-table" v-if="salesType !== 2">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            :header-cell-style="{
              color: '#333333',
              fontSize: '14px',
              backgroundColor: '#f5f5f5',
            }"
            class="attr-table"
          >
            <el-table-column prop="attributeName" label="属性" width="180">
              <!-- eslint-disable-next-line -->
              <template slot-scope="scope">
                <span>
                  <i class="red-star">*</i>
                  {{ scope.row.attributeName }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="attributeValueList" label="属性值">
              <!-- eslint-disable-next-line -->
              <!-- <template slot="header" slot-scope="scope">
								<div class="search-wrap">
                                    <span>属性值</span>
                                    <el-input style="width:180px" placeholder="请输入查询" suffix-icon="el-icon-search" v-model="searchVal" @input="handelSearchVal">
                                    </el-input>
								</div>
                            </template> -->
              <!-- eslint-disable-next-line -->
              <template slot-scope="scope">
                <!-- <span class="attr-item" :class="{active:item.checked == true}" @click="attrHandle(item.attributeValueId,scope.$index)" v-for="item in scope.row.attributeValueList" :key="item.attributeValueId">
                     {{ item.attributeValue }}
                </span> -->
                <el-radio-group
                  v-model="ruleForm.attrCheckList[scope.$index]"
                  @change="
                    (val) => {
                      attrHandle(val, scope.$index);
                    }
                  "
                >
                  <el-radio
                    v-for="item in scope.row.attributeValueList"
                    :key="item.attributeValueId"
                    :label="item.attributeValue"
                  >
                    {{ item.attributeValue }}
                    <img
                      v-show="!item.attributeValueId"
                      @click.stop="deleteAttr(scope.row, item.attributeValue)"
                      class="icon-delete"
                      src="../../../../../assets/img/product/icon-delete@2x.png"
                      alt=""
                    />
                  </el-radio>
                </el-radio-group>
                <el-input
                  class="attr-input"
                  v-if="scope.row.customFlag == 1"
                  style="width: 100px; margin-right: 10px; margin-left: 10px"
                  v-model.trim="attrValue[scope.$index].val"
                  placeholder="请输入内容"
                ></el-input>
                <div
                  class="add-attr-btn"
                  v-if="scope.row.customFlag == 1"
                  @click="addAttr(scope.row, scope.$index)"
                >
                  <i class="el-icon-plus"></i>
                </div>
                <!-- <el-button v-if="scope.row.customFlag==1" @click="addAttr(scope.row,scope.$index)"><i
										class="el-icon-plus"></i></el-button> -->
              </template>
            </el-table-column>
            <el-table-column prop="unitList" label="计量单位" width="260">
              <!-- eslint-disable-next-line -->
              <template slot="header" slot-scope="scope">
                <span>
                  <i class="red-star">*</i>
                  计量单位
                </span>
              </template>
              <!-- eslint-disable-next-line -->
              <template slot-scope="scope">
                <!-- <span class="attr-item" :class="{active:unititem.checked == true}" @click="unitHandle(unititem.unitId,scope.$index)" v-for="unititem in scope.row.unitList" :key="unititem.unitId+scope.$index">
                     {{ unititem.unitName}}
                </span> -->
                <el-radio-group
                  v-model="ruleForm.unitCheckList[scope.$index]"
                  @change="
                    (val) => {
                      unitHandle(val, scope.$index);
                    }
                  "
                >
                  <el-radio
                    v-for="unititem in scope.row.unitList"
                    :key="unititem.unitId"
                    :label="unititem.unitName"
                  >
                    {{ unititem.unitName }}
                  </el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="title">
        <span>商品销售规则</span>
      </div>
      <div class="info-content">
        <div class="info-form">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
            label-position="top"
          >
            <!-- <el-row>
              <div class="brand-box">
                <el-form-item label="销售范围" prop="saleArea">
                  <el-select
                    style="width: 300px"
                    v-model="ruleForm.salesScope"
                    placeholder="请选择"
                  >
                    <el-option label="全平台" value="1"></el-option>
                    <el-option label="协议客户" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <div class="rule-content">
                  <el-tooltip class="item" placement="right">
                    <div slot="content">
                      销售范围<br />1、商品在国内可以售卖区域
                    </div>
                    <el-button type="text"
                      ><i class="el-icon-question"></i
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </el-row> -->
            <el-row>
              <div class="brand-box">
                <el-form-item label="可售区域设置:" prop="salesScopeId">
                  <span slot="label">
                    <span>可售区域设置:</span>
                    <el-tooltip class="item" effect="dark" placement="right">
                      <div slot="content">
                        运费规则设置：
                        <br />
                        1、商品在国内可以售卖区域
                      </div>
                      <!-- <el-button type="text"><i class="el-icon-question"></i></el-button> -->
                      <!-- <img src="@/assets/img/product/doubt.png" class='item-img' alt=""> -->
                      <span class="tip-icon">?</span>
                    </el-tooltip>
                  </span>
                  <el-select
                    style="width: 300px"
                    v-model="ruleForm.salesScopeId"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="areaitem in areaList"
                      :key="areaitem.salesScopeId"
                      :label="areaitem.salesScopeName"
                      :value="areaitem.salesScopeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <div class="rule-content">
                  <span>如无可选，请先</span>
                  <span class="setOver" @click="showAreaSopeDialog"
                    >设置可售区域</span
                  >
                </div>
              </div>
            </el-row>
            <el-row>
              <el-form-item label="备注:">
                <el-input
                  class="text-area"
                  type="textarea"
                  v-model="ruleForm.remark"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="附件:">
                <span slot="label" class="item-title">
                  <i>商品说明附件：</i>
                  最多上传 10个文件，仅限 PDF 格式，文小不能超过 20M
                </span>
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="headers"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  accept=".pdf"
                  :on-success="handleSuccess"
                  :before-upload="handleBeforeUpload"
                  :limit="10"
                >
                  <div class="upload-btn">
                    <i>+</i>
                    <span>请上传附件</span>
                  </div>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div class="ope-content">
      <el-button @click="goToUrl('/createProductsFirst')">上一步</el-button>
      <el-button class="next-btn" type="primary" @click="nextStep"
        >下一步</el-button
      >
    </div>
    <AddSalesTerritory
      ref="addDialog"
      title="新增"
      :form="form"
      :visible="dialogVisible"
      @cancel="handleCancel"
      @save="saveEdit"
    ></AddSalesTerritory>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import api from '../../../api/product/index.js';
// import util from "../../../utils/utils";
import AddSalesTerritory from '../../../pages/product/addSalesTerritory.vue';
import utils from '../../../utils/utils';
import { epecToken } from '../../../utils/globalData';
import bus from '../../../../../components/common/bus';
export default {
  data() {
    return {
      uploadUrl: api.fileUploadForProductFile,
      headers: epecToken,
      form: {},
      dialogVisible: false, //zing
      isActiveUnit: '', //当前选中单位
      taxList: [],
      brandList: [], //品牌列表
      ruleForm: {
        category: '动力传动-轴承及其工具-球轴承',
        tax: '',
        brand: '',
        brandName: '',
        brandNameEN: '',
        salesScope: '',
        salesScopeId: -1,
        attrCheckList: [], //选择的属性值集合
        unitCheckList: [],
        taxName: '',
        attributeStr: '',
        attributes: [],
        remark: null, //备注
        skuFiles: [], //商品附件
        showTax: null,
      },
      rules: {
        tax: {
          required: true,
          message: '请选择税率',
          trigger: 'change',
        },
        salesScopeId: {
          required: true,
          message: '请选择税率',
          trigger: 'change',
        },
      },
      tableData: [],
      attrValue: [], //属性值
      areaList: [
        {
          salesScopeId: 1,
          salesScopeName: '测试',
        },
      ], //可售区域
      fileList: [],
      searchVal: null,
      salesType: null, //商品类型 1标品2非标品
    };
  },

  components: {
    AddSalesTerritory,
  },

  computed: {
    ...mapState(['productList']),
  },

  created() {
    // console.log('组件')
    this.ruleForm.category = this.$getStore('categoryName');
    this.salesType = Number(this.$getStore('salesType'));
    this.initData();
  },
  activated() {
    let newCategory = this.$getStore('categoryName');
    let oldCategory = this.ruleForm.category;
    if (newCategory != oldCategory) {
      this.ruleForm.category = newCategory;
      let id = this.$store.state.productList.categoryId;
      this.salesType = Number(this.$getStore('salesType'));
      this.getBrandList(id);
      this.getPropertyList(id);
      this.ruleForm.brand = '';
      this.ruleForm.brandName = '';
      this.ruleForm.brandNameEN = '';
      this.ruleForm.tax = '';
      this.ruleForm.showTax = '';
    }
  },
  methods: {
    ...mapMutations(['PRODUCT_LIST', 'PRODUCT_LIST_1', 'CATEGORY_LIST']),
    initData() {
      let id = this.$store.state.productList.categoryId;
      this.getBrandList(id);
      this.getPropertyList(id);
      this.getSalesAreaList();
      this.getTaxRateList();
    },
    goToUrl() {
      bus.$emit('changeStep', 0);
      // this.$router.push({ path: url });
    },
    goToApply() {
      this.$router.push({
        path: '/brandProtocol',
        query: { from: 'createProduct' },
      });
    },
    async getTaxRateList() {
      let res = await api.getTaxRateList();
      console.log(res);
      if (res.code == 200) {
        this.taxList = res.data;
        this.taxList.map((item) => {
          if (item.taxRate == 13) {
            this.ruleForm.taxName = item.taxRate;
            this.ruleForm.tax = item.taxRateId;
            this.ruleForm.showTax = item.taxRate + '%';
          }
        });
      }
    },
    attrHandle(value, index) {
      console.log(value);
      console.log(index);
      //  this.$nextTick(() => {
      let arr = [];
      let that = this;
      this.tableData[index].attributeValueList.map((item) => {
        if (item.attributeValue == value) {
          item.checked = true;
          // this.ruleForm.attrCheckList.push({ id: item.attributeValueId });
          console.log(that.ruleForm.attrCheckList);
          // that.ruleForm.attrCheckList[index]['attrVal'] = item.attributeValue;
        } else {
          item.checked = false;
        }
        arr.push(item);
      });
      // })
      this.$set(this.tableData[index], 'attributeValueList', arr);
      console.log(this.tableData);
      console.log(this.ruleForm);
    },
    unitHandle(value, index) {
      console.log(value);
      // this.isActiveUnit = value
      let arr = [];
      this.tableData[index].unitList.map((item) => {
        if (item.unitName == value) {
          item.checked = true;
          //  this.ruleForm.unitCheckList.push({ id: item.unitId });
          // this.ruleForm.attrCheckList[index].unitVal = item.unitId;
        } else {
          item.checked = false;
        }
        arr.push(item);
      });
      this.$set(this.tableData[index], 'unitList', arr);
      console.log(this.tableData);
      console.log(this.ruleForm);
    },
    //属性搜索
    // handelSearchVal(val){
    //   let arr = this.selStandardObj.attributeValueList;
    //   console.log(arr.filter(item => (item.attributeValue).indexOf(val)!=-1));
    //   let newArr = arr.filter(item => (item.attributeValue).indexOf(val)!=-1)
    //   this.$set(this.selStandardObj,'attributeValueList',newArr);
    //   if(!val){
    //             this.selStandardObj = JSON.parse(localStorage.getItem('selStandardObj'));
    //           }

    // },
    //   添加属性
    addAttr(row, index) {
      console.log(row);
      if (utils.deleteSpace(this.attrValue[index].val) == '') {
        this.$message.warning('属性值不能为空');
        return;
      }
      if (
        utils.getArgumentIndexInAttr(
          row.attributeValueList,
          'attributeValue',
          this.attrValue[index].val
        ) == -1
      ) {
        if (utils.deleteSpace(this.attrValue[index].val).length > 20) {
          this.$message.warning('属性值不能超过20个字');
          return;
        } else {
          row.attributeValueList.push({
            attributeValue: this.attrValue[index].val,
            checked: false,
          });
          this.attrValue[index].val = '';
        }
      } else {
        this.$message.warning('属性值不能重复');
      }

      // this.attrValue = [];
      console.log(this.tableData);
      // row.name.push(this.attrValue);
    },
    //删除属性
    deleteAttr(row, val) {
      console.log(
        utils.getArgumentIndexInAttr(
          row.attributeValueList,
          'attributeValue',
          val
        )
      );
      let index = utils.getArgumentIndexInAttr(
        row.attributeValueList,
        'attributeValue',
        val
      );
      row.attributeValueList.splice(index, 1);
      // this.ruleForm.attrCheckList = [];
      console.log(this.ruleForm);
    },
    //获取品牌列表
    async getBrandList(id) {
      let res = await api.getBrandByCategory({
        categoryId: id,
      });
      if (res.code == 200) {
        this.brandList = res.data;
      } else {
        this.$message.error(res.message);
        return;
      }
      //  console.log(res);
    },
    //获取属性列表
    async getPropertyList(id) {
      let res = await api.getPropertyByCategory({
        categoryId: id,
        attributeType: 1,
      });
      if (res.code == 200) {
        this.tableData = res.data;
        this.tableData.map((item) => {
          // this.ruleForm.attrCheckList.push({attrVal:'',unitVal:''});
          item.attributeValueList.map((subitem) => {
            subitem.checked = false;
            this.attrValue.push({
              val: '',
            });
          });
        });
      } else {
        this.$message.error(res.message);
        return;
      }
      console.log(this.ruleForm);
    },
    //获取销售区域列表
    async getSalesAreaList() {
      let res = await api.getSalesArea();
      if (res.code == 200) {
        this.areaList = res.data;
      }
    },
    selectRate(val) {
      console.log(val);
      let obj = utils.getSelectLabel(this.taxList, val, 'taxRateId');
      console.log(obj);
      this.ruleForm.taxName = obj.taxRate;
      this.ruleForm.tax = obj.taxRateId;
      this.ruleForm.showTax = obj.taxRate + '%';
      // this.$set(this.ruleForm,'showTax', (obj.taxRate + '%'))
      console.log(this.ruleForm);
    },
    selectBrand(val) {
      let obj = utils.getSelectLabel(this.brandList, val, 'brandId');
      console.log(obj);
      this.ruleForm.brandName = obj.brandName;
      this.ruleForm.brandNameEN = obj.brandNameEN;
      this.ruleForm.brand = obj.brandId;
    },
    //组装属性字符串
    assembleAttrString() {
      let temStr = '';
      this.tableData.map((item) => {
        let subStr = '';
        item.attributeValueList.map((attritem) => {
          if (attritem.checked == true) {
            subStr += attritem.attributeValue;
          }
        });
        item.unitList.map((unititem) => {
          if (unititem.checked == true) {
            subStr += unititem.unitName;
          }
        });
        let beforeSymbol = item.beforeSymbol ? item.beforeSymbol : '';
        let behindSymbol = item.behindSymbol ? item.behindSymbol : '';
        let connectSymbol = item.connectSymbol ? item.connectSymbol : '';
        temStr +=
          beforeSymbol +
          // item.attributeName +
          subStr +
          behindSymbol +
          connectSymbol;
      });
      console.log(temStr);
      return temStr;
    },
    //判断商品是否存在
    async checkProductExist(str, cid, tid, bid) {
      let params = {
        attributeStr: str,
        categoryId: cid,
        taxRateId: tid,
        brandId: bid,
        supplierCompanyId: this.$store.state.USERINFO.companyId,
      };
      let isExist = true;
      let res = await api.checkProductExist(params);
      console.log(res);
      if (res.code == 200) {
        isExist = false;
        if (utils.isEmptyObject(res.data)) {
          localStorage.setItem('isExistProductGroup', false);
          localStorage.setItem('isExistProductGroupProductId', null);
        } else {
          localStorage.setItem('isExistProductGroup', true);
          localStorage.setItem(
            'isExistProductGroupProductId',
            res.data.productId
          );
        }
      } else {
        this.$message.error(res.message);
        return;
      }
      return isExist;
    },
    //拼接属性字符串 发布商品时用到
    assembleAttrStr(arr) {
      // debugger
      let str = '';
      for (let i = 0; i < arr.length; i++) {
        // let beforeSymbol = arr[i].beforeSymbol ? arr[i].beforeSymbol : ''
        // str += beforeSymbol + arr[i].attributeName;
        let beforeSymbol = arr[i].beforeSymbol ? arr[i].beforeSymbol : '';
        str += beforeSymbol;
        for (let j = 0; j < arr[i].attributeValueList.length; j++) {
          if (arr[i].attributeValueList[j].checked == true) {
            str += arr[i].attributeValueList[j].attributeValue;
          }
        }
        for (let k = 0; k < arr[i].unitList.length; k++) {
          if (arr[i].unitList[k].checked == true) {
            str += arr[i].unitList[k].unitName;
          }
        }
        let behindSymbol = arr[i].behindSymbol ? arr[i].behindSymbol : '';
        str += behindSymbol + arr[i].connectSymbol;
      }
      return str;
    },
    //组装属性对象 发布商品时用到
    assembleAttrObj(arr) {
      let temArr = [];
      for (let i = 0; i < arr.length; i++) {
        let temObj = {
          attributeId: '',
          attributeName: '',
          attributeValueId: '',
          attributeValue: '',
          unitId: '',
          unitValue: '',
        };
        temObj.attributeId = arr[i].attributeId;
        temObj.attributeName = arr[i].attributeName;
        for (let j = 0; j < arr[i].attributeValueList.length; j++) {
          if (arr[i].attributeValueList[j].checked == true) {
            temObj.attributeValueId =
              arr[i].attributeValueList[j].attributeValueId;
            temObj.attributeValue = arr[i].attributeValueList[j].attributeValue;
          }
        }
        for (let k = 0; k < arr[i].unitList.length; k++) {
          if (arr[i].unitList[k].checked == true) {
            temObj.unitId = arr[i].unitList[k].unitId;
            temObj.unitValue = arr[i].unitList[k].unitName;
          }
        }
        temArr.push(temObj);
      }
      return temArr;
    },
    checkListHasEmpry(arr) {
      let flag = false;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] == '') {
          flag = true;
          break;
        }
      }
      return flag;
    },
    // 判断属性单位个数
    checkAttrTotal(arr) {
      let num = 0;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].unitList.length > 0) {
          num++;
        }
      }
      return num;
    },
    nextStep() {
      if (this.ruleForm.tax == '') {
        this.$message.warning('请选择税率');
        return;
      }
      if (this.ruleForm.salesScopeId == '') {
        this.$message.warning('请选择可售区域');
        return;
      }
      if (this.salesType !== 2) {
        //非标商品不用判断属性
        let AttrValueIsAllCheckedFlag = this.checkAttrValueIsAllChecked(
          this.tableData
        );
        let unitValueIsAllCheckedFlag = this.checkUnitValueIsAllChecked(
          this.tableData
        );
        if (this.tableData.length > 0) {
          if (!AttrValueIsAllCheckedFlag) {
            this.$message.warning('请选择属性');
            return;
          }
          if (!unitValueIsAllCheckedFlag) {
            this.$message.warning('请选择单位');
            return;
          }
        }
        let str = this.assembleAttrString();
        let cid = this.$store.state.productList.categoryId;
        let tid = this.ruleForm.tax;
        let bid = this.ruleForm.brand;
        this.checkProductExist(str, cid, tid, bid);
        this.ruleForm.attributes = this.assembleAttrObj(this.tableData);
        console.log(this.ruleForm);
        this.ruleForm.attributeStr = this.assembleAttrStr(this.tableData);
      }
      // let str = this.assembleAttrString();
      // let cid = this.$store.state.productList.categoryId;
      // let tid = this.ruleForm.tax;
      // let bid = this.ruleForm.brand;
      // this.checkProductExist(str, cid, tid, bid);
      // this.ruleForm.attributes = this.assembleAttrObj(this.tableData);
      // console.log(this.ruleForm);
      // this.ruleForm.attributeStr = this.assembleAttrStr(this.tableData);
      this.PRODUCT_LIST_1(this.ruleForm);
      this.CATEGORY_LIST(this.tableData);
      bus.$emit('changeStep', 2);
      // this.$router.push({ path: "/createProductsThird" });
    },

    // 判断属性值是否全选
    checkAttrValueIsAllChecked(arr) {
      let flag = false;
      for (let i = 0; i < arr.length; i++) {
        let attributeValueList = arr[i].attributeValueList;
        for (let j = 0; j < attributeValueList.length; j++) {
          if (attributeValueList[j].checked === true) {
            flag = true;
            break;
          } else {
            flag = false;
            continue;
          }
        }
        if (flag === false) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    // 判断计量单位值是否全选
    checkUnitValueIsAllChecked(arr) {
      let flag = true;
      for (let i = 0; i < arr.length; i++) {
        let unitList = arr[i].unitList;
        if (unitList.length > 0) {
          for (let j = 0; j < unitList.length; j++) {
            if (unitList[j].checked === true) {
              flag = true;
              break;
            } else {
              flag = false;
              continue;
            }
          }
        }
        if (flag === false) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    // 查询属性单位是否为空
    checkAttrAndUnitIsEmpty(arr) {
      let flag = false;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].length == 0) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    saveEdit(val) {
      this.dialogVisible = false;
      for (let i = 0; i < val.result.length; i++) {
        for (let j = 0; j < val.checkedKeys.length; j++) {
          if (val.checkedKeys[j] === val.result[i].areaCode) {
            val.result[i].isSale = 1;
          }
        }
      }

      console.log(val);
      console.log(val.result);
      let addParams = {};
      addParams.salesScopeName = val.salesScopeName;
      addParams.salesScopeAreas = val.result;
      api.addSalesScope(addParams).then((res) => {
        if ('success' === res.data) {
          this.$message({
            showClose: true,
            message: '新增销售区域成功',
            type: 'success',
          });
          this.getSalesAreaList();
        } else {
          this.$message({
            showClose: true,
            message: '新增销售区域失败,失败原因:' + res.message,
            type: 'success',
          });
        }
      });
    },
    showAreaSopeDialog() {
      console.log('这是第一个');
      this.form = {};
      this.$refs.addDialog.setDisabledFlag(false);
      this.$refs.addDialog.assembleTreeData();
      this.$refs.addDialog.handleClear();
      this.dialogVisible = true;
    },
    //附件上传成功处理
    handleSuccess(file) {
      console.log(file);
      this.ruleForm.skuFiles.push({
        fileName: file.data.fileName,
        fileUrl: file.data.url,
      });
    },
    handleRemove(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (
        utils.getArgumentIndexInAttr(
          this.ruleForm.skuFiles,
          'fileUrl',
          file.response.data.url
        ) != -1
      ) {
        this.ruleForm.skuFiles.splice(
          utils.getArgumentIndexInAttr(
            this.ruleForm.skuFiles,
            'fileUrl',
            file.response.data.url
          ),
          1
        );
      }
      console.log(this.ruleForm.skuFiles);
    },
    handleBeforeUpload(file) {
      console.log(file);
      let length = file.name.length;
      length = length - 4;
      console.log(length);
      let size = file.size / 1024 / 1024;
      let type = file.type;
      if (type != 'application/pdf') {
        this.$message.warning('文件为pdf格式');
        return false;
      }
      if (size > 20) {
        this.$message.warning('文件不能超过20M');
        return false;
      }
      if (length > 50) {
        this.$message.warning('您上传的附件名称太长');
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
@import '@/assets/css/theme.scss';

::v-deep.el-radio-group {
  line-height: 30px;
}

::v-deep .el-radio__label {
  color: #333333;
  font-style: normal;
  font-family: Source Han Sans CN;
}

::v-deep .el-textarea {
  border-radius: none;
}
::v-deep .el-radio {
  word-break: break-all;
  white-space: normal;
}
/* .setOver:hover {
		text-decoration: underline;
	} */

.attr-table {
  ::v-deep.el-table .cell {
    line-height: 40px;
  }
}

.ope-content {
  text-align: center;
  margin-top: 20px;
}

.container {
  min-width: 1200px;
  .red-star {
    color: #ef4c56;
    margin-right: 5px;
  }

  .title {
    // border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;

    span {
      font-size: 16px;
      color: #000;
    }
  }

  /* ::v-deep .el-textarea__inner{
			border-radius:0px;
		} */
  ::v-deep .el-textarea__inner {
    border-radius: 0px !important;
  }

  .info-content {
    margin-top: 15px;

    .brand-box {
      @include flex(start, center, row);
      .tip-wrap {
        color: #999;
        font-size: 14px;
        display: inline-block;
        // height: 33px;
        min-height: 33px;
        margin-left: 10px;
        word-break: break-all;
        i {
          font-style: normal;
          font-weight: bold;
          color: $main-col;
        }
      }
      .apply-brand {
        display: inline-block;
        height: 33px;
        margin-bottom: 16px;
        line-height: 33px;
        color: #0064c8;
        font-size: 14px;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }

  .rule-content {
    @include flex(start, center, row);
    margin-top: 24px;
    margin-left: 10px;

    span {
      font-size: 14px;
      color: #999;

      &:last-child {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }

  .attr-item {
    padding: 8px 10px;
    background: #f5f5f5;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    margin-right: 10px;

    &.active {
      background: #ffe353;
    }
  }

  .item-title {
    color: #999;
    font-size: 14px;

    i {
      font-style: normal;
      font-size: 14px;
      color: #333;
    }
  }

  .upload-btn {
    width: 260px;
    height: 30px;
    padding: 0 0 0 10px;
    border: 1px dotted #999999;
    text-align: left;
    display: flex;
    align-items: center;

    i {
      color: #333;
      font-size: 14px;
      font-style: normal;
    }

    span {
      color: #999;
      font-size: 14px;
    }
  }
  .search-wrap {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
  }
}

.icon-delete {
  width: 14px;
  height: 14px;
}

.text-area::v-deep .el-textarea.el-textarea__inner {
  border-radius: 0 !important;
}

.next-btn {
  width: 120px;
  margin-left: 30px;
}

.el-button {
  font-size: 14px;
}

.attr-input ::v-deep .el-input__inner {
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0 !important;
  line-height: 30px;
  height: 30px;
}
.item-img {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin: 5px 0 0 5px;
}
.tip-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  display: inline-block;
  line-height: 16px;
  text-align: center;
  color: #c5c5c5;
  font-size: 12px;
  cursor: pointer;
  margin-left: 16px;
  &:hover {
    border: 1px solid #d9d9d9;
    color: #fff;
    background: #d9d9d9;
  }
}
</style>
